export const RouteConstants = {
    UNAUTH_DEFAULT: '/login',
    ADMIN_DEFAULT: '/admin/customers',
    CUSTOMER_DEFAULT: '/customer/dashboard',
    REPORTS: '/customer/reporting',
    ADMIN_REPORT_SETTINGS: '/admin/settings/report',
}
